import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { getIn } from 'formik';
import { isNonNullExpression } from 'typescript';

interface CustomSelectProps {
	name: string,
	value: string | number,
	defaultOptionString: string,
	touched: Object,
	errors: Object,
	optionsArray: Array<string | number>,
	errorPath?: string,
	onBlur?: {
		(e: React.FocusEvent<any>): void
	},
	onChange?: {
		(e: React.ChangeEvent<any>): void
	},
	onFocus?: {
		(e: React.FocusEvent<HTMLSelectElement>): void
	},
}

// Custom select dropdown field using formik and react-bootstrap
export const CustomSelect = ({
	name,
	value,
	defaultOptionString,
	touched,
	errors,
	optionsArray,
	errorPath,
	onBlur,
	onChange,
	onFocus,
	...props
}: CustomSelectProps) => {

	return (
		<>
			<Form.Control as="select" custom
				size="sm"
				name={name}
				value={value}
				isValid={getIn(touched, errorPath ||name) &&
					!getIn(errors, errorPath || name)}
				isInvalid={getIn(touched, errorPath || name) &&
					!!getIn(errors, errorPath || name)}
				onChange={onChange}
				onBlur={onBlur}
				onFocus={onFocus}
				style={{color: !optionsArray.includes(value) && value !== "" ? "#dc3545" : "#495057"}} 
			>
				{/* Placeholder blank option when nothing is chosen. Will be removed once anything is selected */}
				{!value ?
					<option value="">{defaultOptionString}</option>
					: null}
				{/* If the currently selected value is no longer a valid option, temporarily keep it as an (invalid) option. Option will disappear when something else is chosen*/}
				{!optionsArray.includes(value) && value !== "" ?
					<option value={value}>{value}</option>
					: null}
				{/* Iterate through input options array and puts each element as an option */}
				{optionsArray.map((element: any) => {
					return (
						<option style={{color: "#495057"}} value={element}>{element}</option>
					)
				})
				}
			</Form.Control>
		</>
	)
}
